import Yup from 'src/services/yup';
import moment from 'moment';
import appConfig from 'src/appConfig';
import { FORM_ERROR } from 'src/appConfig/constanst';

const today = new Date();
today.setHours(0, 0, 0, 0);

const validationOpenDateSchema = Yup.object().shape({
  openDate: Yup.date()
    .typeError('Invalid date.')
    .required(FORM_ERROR.RequiredField)
    .min(today, 'Open date should be the current date or future date.'),
});

const validation = Yup.object().shape({
  caseId: Yup.string().required(FORM_ERROR.RequiredField).max(appConfig.TEXT_SHORT_LENGTH, FORM_ERROR.IDLength),
  name: Yup.string().required(FORM_ERROR.RequiredField).max(appConfig.TEXT_MAX_LENGTH, FORM_ERROR.TextMaxLength),
  actualDepositionDate: Yup.date()
    .typeError('Invalid date.')
    .required(FORM_ERROR.RequiredField)
    .when('openDate', (openDate: any, schema: any) => {
      if (openDate && moment(openDate).isValid()) {
        return schema.min(openDate, 'Actual Deposition Date should be the same as or later than Open date');
      }
    }),
  depositionTime: Yup.date().required().typeError(FORM_ERROR.RequiredField),
  caseName: Yup.string().required(FORM_ERROR.RequiredField).max(appConfig.TEXT_MAX_LENGTH, FORM_ERROR.TextMaxLength),
});

export default (isCreate = true) => {
  let schema = validation;
  if (isCreate) {
    schema = schema.concat(validationOpenDateSchema);
  }
  return schema;
};
